import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SignalRConnectionService } from '../services/signalr-connection.service';

/**
 * HTTP Interceptor that automatically subscribes to SignalR topics
 * when API responses contain a topicId field at the root level.
 */
@Injectable()
export class SignalRTopicInterceptor implements HttpInterceptor {
  constructor(private signalRConnectionService: SignalRConnectionService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event) => {
        if (event instanceof HttpResponse && event.body) {
          const body = event.body;
          if (body && typeof body === 'object' && 'topicId' in body) {
            const topicId = (body as { topicId: unknown }).topicId;
            if (typeof topicId === 'string' && topicId) {
              console.log(`[SignalR Interceptor] Found topicId in response: ${topicId}`);
              this.signalRConnectionService.subscribeToTopic(topicId);
            }
          }
        }
      })
    );
  }
}
